<template>
  <div class="">
    <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h3 class="text-center mb-0 pb-0">{{ modulo.nombre }}</h3>
    <h4 class="text-center mt-0 pt-0">Calificaciones del modulo</h4>
    <v-progress-linear v-if="loading" indeterminate />
    <p class="my-0 mx-2 text-center">
      <b>NOTA:</b>
      Agregue las calificaciones de todos los estudiantes y presione el boton de guardar, asegurese de ingresar todas
      las notas una ves guardada no podra editar ninguna nota a menos que elimine todas y vuelva a ingresar de cada uno.
    </p>
    <p class="mb-0 mx-4 text-center green--text">
      <b
        >Las notas son jaladas desde el moodle, tomando en cuenta el course_id del moodle registrado en cada modulo en
        el sistema esam, debe tomar en cuenta que los estudiantes son enlazados por el username, el mismo username debe
        estar registrado en esam y moodle.</b
      >
    </p>
    <v-alert border="left" colored-border class="mx-2" color="green darken-2" elevation="2">
      <p class="mb-0 text-left"><b>Fecha primera instancia:</b> {{ fecha_primera_instancia }}</p>
      <p class="mb-0 text-left"><b>Fecha segunda instancia:</b> {{ fecha_segunda_instancia }}</p>
      <p class="mb-0 text-left"><b>Instancia a presentar:</b> {{ nro_instancia }}</p>
    </v-alert>

    <div class="row justify-center">
      <div class="col-xs-12 col-md-8">
        <v-data-table
          :headers="headers"
          :items="modulo.inscripciones"
          disable-pagination
          hide-default-footer
          dense
          class="elevation-2 px-8"
        >
          <template v-slot:[`item.index`]="{ item, index }">
            <span :title="'ID: ' + item.id"> {{ index + 1 }} </span>
          </template>
          <template v-slot:[`item.estudiante`]="{ item }">
            <span>
              {{ item.estudiante.primer_apellido }} {{ item.estudiante.segundo_apellido }}
              {{ item.estudiante.nombres }}
            </span>
            <!--  <p class="mt-5">
              <span> [{{ item }}] </span>
            </p>
            <p class="mt-5">[ {{ item.xmodulo_inscripcion }} ]</p> -->
          </template>

          <template v-slot:[`item.xnota_final`]="{ item }">
            <v-text-field
              :disabled="!item.xmodulo_inscripcion"
              :readonly="nro_instancia != 1"
              v-model.number="item.xnota_final"
              type="number"
              outlined
              dense
              hide-details
            />
          </template>

          <template v-slot:[`item.nota_recuperatorio`]="{ item }">
            <v-text-field
              :disabled="!item.xmodulo_inscripcion"
              v-model.number="item.nota_recuperatorio"
              :readonly="nro_instancia != 2"
              type="number"
              outlined
              dense
              hide-details
            />
          </template>
        </v-data-table>
      </div>
    </div>

    

    <p class="text-center">{{ msg }}</p>

    <div class="d-flex justify-center">
      <v-btn class="mt-8 mb-8 green darken-3" :disabled="loading" @click="guardar()" dark tile>
        Guardar notas de {{ literal_instancia_save }} instancia
      </v-btn>

      <v-btn
        class="mt-8 mb-8 red darken-3"
        v-show="fecha_primera_instancia || fecha_segunda_instancia"
        :disabled="loading"
        @click="preeliminarnotasinstancia()"
        dark
        tile
      >
        Eliminar notas de {{ literal_instancia_del }} instancia
      </v-btn>
    </div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import { getheadersrest } from '@/components/Utils';
  export default {
    data: () => ({
      loading: false,
      modulo: { inscripciones: [] },
      posgrado: null,
      msg: '',
      headers: [
        { text: '#', value: 'index', width: 40 },
        { text: 'Estudiante', value: 'estudiante' },
        { text: 'Nota moodle', value: 'xnota_moodle', width: 90 },
        { text: 'Nota final', value: 'xnota_final', width: 110 },
        { text: 'Nota recuperatorio', value: 'nota_recuperatorio', width: 110 },
      ],
      fecha_primera_instancia: null,
      fecha_segunda_instancia: null,
      nro_instancia: 1,
      permitir_ceros: true
    }),

    components: {},
    computed: {
      literal_instancia_save() {
        return this.nro_instancia == 1 ? 'primera' : 'segunda';
      },
      literal_instancia_del() {
        return this.nro_instancia <= 2 ? 'primera' : 'segunda';
      },
    },
    watch: {},

    methods: {
      cargarInscritos() {
        let vue = this;
        this.loading = true;
        this.modulo = { inscripciones: [] };
        this.nro_instancia = 1;
        let idmodulo = this.$route.query.idmodulo;
        let courseid = this.$route.query.course_id;
        const plataformaId = this.$route.query.plataforma_id;
        const promise1 = xaxios.get(`${process.env.VUE_APP_API_REST}/esam/inscripcion/modulo/id/${idmodulo}`);
        const promise2 = xaxios.get(
          `${process.env.VUE_APP_API_REST}/esam/programa/modulo/course/id/${courseid}/inscripcion`,
        );
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
          /\/$/,
          '',
        )}/plataformas/${plataformaId}/course/id/${courseid}/enrolment/gradeitem/grade`;
        const promise3 = xaxios.get(url);
        const url2 = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(
          /\/$/,
          '',
        )}/plataformas/${plataformaId}/course/id/${courseid}/gradeitem`;
        const promise4 = xaxios.get(url2);

        Promise.all([promise1, promise2, promise3, promise4])
          .then(function(values) {
            let data = values[0].data;
            let inscripcion = values[1].data;
            let grades = values[2].data;
            let gradesdetals = values[3].data;
            vue.loading = false;
            //window.console.log('>>values: ', values);
            window.console.log('Values:::', values);

            vue.fecha_primera_instancia = inscripcion.fecha_primera_instancia;
            vue.fecha_segunda_instancia = inscripcion.fecha_segunda_instancia;
            if (inscripcion.fecha_primera_instancia) vue.nro_instancia = 2;
            if (inscripcion.fecha_segunda_instancia) vue.nro_instancia = 3;
            data.inscripciones.sort((a, b) => {
              return a.estudiante.primer_apellido.localeCompare(b.estudiante.primer_apellido);
            });
            data.inscripciones.forEach((x) => {
              let inmoodle = inscripcion.modulo_inscripciones.find((m) => m.estudiante_id == x.estudiante_id);
              if (!grades.enrolments) {
                grades.enrolments = [];
              }
              let moodleuser = grades.enrolments.find((mu) => mu.user.username == x.estudiante.usuario_moodle);
              if (inmoodle) {
                x.xmodulo_inscripcion = inmoodle;
                x.xnota_final = inmoodle.nota_final;
                x.nota_recuperatorio = inmoodle.nota_recuperatorio;
              }

              if (moodleuser) {
                x.xenrolment = moodleuser;
                if (!grades.course_students_grades) grades.course_students_grades = [];
                let notas = grades.course_students_grades.find((gr) => gr.user_id == moodleuser.user_id);
                if (notas) {
                  let nota_final = 0;
                  notas.student_grades.forEach((n) => {
                    let deta = gradesdetals.grade_items.find((dt) => dt.id == n.item_id);
                    n.xdetallemod = deta;
                    let nombre = deta.item_name.toLowerCase();
                    if (!nombre.includes('recuperatorio')) nota_final += n.final_grade;
                  });
                  x.xnota_moodle = Math.round(nota_final);
                  // con 2 decimales, descomentar
                  // x.xnota_moodle = Math.round((nota_final + Number.EPSILON) * 100) / 100;
                  if (!x.xnota_final) x.xnota_final = x.xnota_moodle;
                }
                x.xnotas = notas;
              }
            });
            vue.modulo = data;
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
        this.getDatos();
      },
      getDatos() {
        let idpostgrado = this.$route.query.idpostgrado;
        const qs = gql`query{ getPostgrado(id:${idpostgrado}){ id nombre carga_horaria } }`;
        this.$apollo
          .query({ query: qs })
          .then(({ data: { getPostgrado } }) => {
            this.posgrado = getPostgrado;
          })
          .catch(() => this.$root.$notify.show(`No hay datos`, { color: 'primary' }));
      },
      async guardar() {
        let vue = this;
        let input = {};
        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        input.fecha_presentacion = date.toISOString().substr(0, 10);
        input.programa_modulo_id = parseInt(this.$route.query.idmodulo);
        input.inscripciones_modulo = [];
        let noenlazados = 0;
        let notaszeros = 0;
        let fs = input.fecha_presentacion.split('-');
        let fecha_p = `${fs[2]}/${fs[1]}/${fs[0]}`;
        input.fecha_presentacion = fecha_p;
        let notasmayor100 = 0;
        this.modulo.inscripciones.forEach((x) => {
          if (x.xmodulo_inscripcion) {
            let not = {};
            not.inscripcion_id = x.inscripcion_id;
            not.inscripcion_modulo_id = x.id;
            not.nota = vue.nro_instancia == 1 ? x.xnota_final : x.nota_recuperatorio;

            if (not.nota || this.permitir_ceros) input.inscripciones_modulo.push(not);
            else notaszeros += 1;
            if (not.nota > 100) notasmayor100 += 1;
          } else {
            noenlazados += 1;
          }
        });

        if (notasmayor100 > 0) {
          this.$root.$notify.show(`Hay ${notasmayor100} notas mayores a 100 no validas`, {
            color: 'danger',
            x: 'left',
          });
          return;
        }

        let url = `${process.env.VUE_APP_API_REST}/esam/nota/programa/modulo/${this.literal_instancia_save}/instancia`;
        let texto = `No enlazados: ${noenlazados}, sin calificar: ${notaszeros}, para calificar: ${input.inscripciones_modulo.length}`;
        window.console.log(JSON.stringify(input, null, 4), url, texto);

        let message = {
          title: `confirmacion necesaria: ${this.literal_instancia_save} instancia.`,
          body: texto,
        };
        let dialogo = await this.$dialog
          .confirm(message)
          .then((dialog) => dialog)
          .catch(() => {});
        if (!dialogo) return;

        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
          data: input,
        };

        xaxios.request(config)
          .then(({ data }) => {
            window.console.log(data);
            vue.cargarInscritos();
          })
          .catch((e) => {
            window.console.log(e);
            vue.loading = false;
          });
      },

      preeliminarnotasinstancia() {
        this.msg = '';
        var vue = this;
        var message = {
          title: 'Confirme que desea proceder',
          body: `<br/>NOTA: Esta accion eliminara todas las notas de ${this.literal_instancia_del} instancia, el cambio no es reversible, solo use esta opcion si
            realmente quiere eliminar las notas, debido a un mal llenado para posteriormente volver a ingresar los corregidos. .<br/>`,
        };
        var options = {
          html: true,
          okText: 'Proceder',
          cancelText: 'Cancelar',
          reverse: true,
          type: 'hard',
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para proceder.',
          loader: true,
        };
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            vue.eliminarnotainstancia(dialog, vue.literal_instancia_del);
          })
          .catch(function() {
            window.console.log('ERROR');
          });
      },

      eliminarnotainstancia(dialog, instancia) {
        let idmodulo = this.$route.query.idmodulo;
        let myHeaders = getheadersrest();
        let vue = this;

        var requestOptions = {
          method: 'DELETE',
          redirect: 'follow',
          headers: myHeaders,
        };
        let urlinstancia =
          process.env.VUE_APP_API_REST + `/esam/nota/programa/modulo/id/${idmodulo}/${instancia}/instancia`;
        fetch(urlinstancia, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            dialog.close();
            window.console.log(result);
            vue.cargarInscritos();
          })
          .catch(() => {
            dialog.close();
            vue.msg = 'No se pudo eliminar las notas';
          });
      },
    },
    mounted() {
      this.cargarInscritos();
    },
  };
</script>
